export var ErrorCodes;

(function (ErrorCodes) {
  ErrorCodes["ERROR_UNKNOWN_ERROR"] = "UnknownError";
  ErrorCodes["ERROR_INTERNAL_ERROR"] = "InternalError";
  ErrorCodes["ERROR_THIRD_PARTY_API_ERROR"] = "ThirdPartyApiError";
  ErrorCodes["ERROR_INVALID_PARAMETER"] = "InvalidParameter";
})(ErrorCodes || (ErrorCodes = {}));